export default __webpack_public_path__ + "static/bbby-pipeline-1-70f7a60daaaf9ca91283a847f35313b3.webp";